import { getAxios } from '@smg-real-estate/hg-networking';

export const internalAxios = getAxios();
